import * as React from "react";
import { IUsersAnalytics } from "../../../utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics";
import { observable, computed } from "mobx";
import BaseComponent from "../../../utility/BaseComponent";
import { observer } from "mobx-react";
import "./static/UsersAnalytics.scss";
import { CardText, Card, CardTitle } from "react-md";
import { LineChart } from 'react-easy-chart';
import { isNullOrUndefined } from "util";
import { IBaseModel } from "../../../utility/IBaseModel";
import * as moment from 'moment';

const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug",
    "Sep", "Oct", "Nov", "Dec"
];
export class UsersAnalyticsModel implements IBaseModel {
    
    @observable analytics: IUsersAnalytics;
    @computed get chartData(): Array<{x: string, y: number}> {
        let registeredChartData: Array<{x: string, y: number}> = [];
        this.analytics.getUserCountPerMonth().forEach(
            ( (count, month) => {
                let year = month.slice(month.length - 5, month.length);
                registeredChartData.push( { x: `${months[Number(month.replace(year, ""))]} ${year
                    .replace(" ", "")}`, y: count } );
            } )
        );
        if (registeredChartData.length <= 7) {
            return registeredChartData;
        } else {
            return registeredChartData.slice(
                registeredChartData.length - 7,
                registeredChartData.length
            );
        }

    }
    @computed get usersThisMonth() {
        let currentDate = moment().toDate();
        let count = 0;
        if (!isNullOrUndefined(this.analytics.getUserCountPerMonth())) {
            let existing = this
            .analytics.getUserCountPerMonth()
            .get(`${currentDate.getMonth()} ${currentDate.getFullYear()}`);
            if (!isNullOrUndefined(existing)) {
                count += existing;
            }
        }
        return count;
    }    constructor(analytics: IUsersAnalytics) {
        this.analytics = analytics;
    }
    // tslint:disable-next-line:no-empty
    prepare() {
    }
} 

@observer class UsersAnalytics extends BaseComponent<{model: UsersAnalyticsModel}, {}> {
    
    render() {
        
        return ( 
            <div className="UsersAnalyticsContainer">
                <Card className="UsersAnalyticsRegisteredUsersCard">
                    <CardTitle title="Registered" subtitle="Analytics on registered users"/>
                    <CardText className="UsersAnalyticsData" >
                    <div className="UsersAnalyticsRegisteredUsersChart" >

                        <LineChart 
                            axes={true}
                            xType={'text'}
                            width={650}
                            xTicks={7}
                            height={250}
                            lineColors={["#35BCEE"]}
                            data={[this.props.model.chartData]}
                        />
                        </div>

                        <div className="UsersAnalyticsRegisteredUsersNumericData">
                            <div >
                                <h4>Total</h4>
                                <h2>{this.props.model.analytics.getUsersCount()}</h2>
                            </div>
                            <div>
                                <h4>This Month</h4>
                                <h2>{this.props.model.usersThisMonth}</h2>

                            </div>
                            <div>
                                <h4>Monthly Avg.</h4>
                                <h2>{Math.floor(this.props.model.analytics.getAvgNewUserPerMonth())}</h2>
                            </div>

                        </div>
                    </CardText>

                </Card>
            </div>
        );
    }
}
export default UsersAnalytics;


// WEBPACK FOOTER //
// ./src/view/Admin/UsersAnalytics/UsersAnalytics.tsx